import React from "react";
import { Quote, Star } from "lucide-react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

function Testimonials() {
  const reviews = [
    {
      name: "Rahul Sharma",
      branch: "Mechanical Engineering",
      text: "The internship helped me apply my classroom knowledge to real-world projects. The mentors were very supportive and I learned a lot.",
    },
    {
      name: "Priya Verma",
      branch: "Computer Engineering",
      text: "It was a great experience working on live projects. This internship boosted my confidence and improved my technical skills.",
    },
    {
      name: "Amit Singh",
      branch: "Electrical Engineering",
      text: "The practical training and guidance helped me understand industry-level work and project development.",
    },
    {
      name: "Aditya Sharma",
      branch: "Civil Engineering",
      text: "Working on practical assignments and live projects gave me confidence and helped me understand real industry workflows.",
    },
    {
      name: "Dhananjay Rathore",
      branch: "Information Technology",
      text: "The internship provided excellent exposure to web technologies, teamwork, and professional project management.",
    },
    {
      name: "Karan Mehta",
      branch: "Electronics Engineering",
      text: "The mentors were knowledgeable and supportive. I gained valuable technical skills and hands-on project experience.",
    },
  ];

  return (
    <section className="relative bg-white dark:bg-[#050505] py-16 px-6 lg:px-16">
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary/20 blur-[140px] rounded-full"></div>
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-orange-300/20 blur-[140px] rounded-full"></div>

      <div className="absolute inset-0 bg-[linear-gradient(rgba(0,0,0,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.03)_1px,transparent_1px)] dark:bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:70px_70px]"></div>

      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold uppercase text-gray-900 dark:text-white">
            What Our Interns Say
          </h2>
          <div className="w-16 h-1 bg-primary mx-auto mt-3 rounded-full"></div>
        </div>

        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={30}
          slidesPerView={3}
          autoplay={{ delay: 2500, disableOnInteraction: false }}
          loop={true}
          breakpoints={{
            0: { slidesPerView: 1 },
            460: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
          }}
          className="pb-12"
        >
          {reviews.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="h-full rounded-xl border border-gray-200 dark:border-white/10 bg-white dark:bg-white/5 p-8 shadow-sm dark:shadow-[0_0_35px_rgba(254,120,83,0.08)]">
                <Quote className="w-8 h-8 text-primary mb-4" />

                <p className="text-sm leading-relaxed text-gray-700 dark:text-gray-300">
                  {item.text}
                </p>

                <div className="mt-6 flex items-end justify-between gap-4">
                  <div>
                    <h3 className="text-sm font-bold text-gray-900 dark:text-white">
                      {item.name}
                    </h3>
                    <p className="text-xs text-gray-500 dark:text-gray-400">
                      {item.branch}
                    </p>
                  </div>

                  <div className="flex gap-1 text-primary">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <Star key={star} className="w-4 h-4 fill-current" />
                    ))}
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}

export default Testimonials;
